import React, {FC} from 'react';
import styled from 'styled-components';

import {RelativeDateTimeFormatsEnum} from '../../../../../../libs/shared/ui/src/components/datetime/relativeDateTimeFormatter';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {InteractiveDateTimeFormatter} from '../../../../common/formatters/dateTime/interactiveDateTimeFormatter';

interface SynopsisTimestampProps {
  timestamp: number;
}

const StyledTimestampDiv = styled.div`
  font-size: ${fontSizes.tiny};
  font-weight: ${fontWeights.medium};
  text-transform: uppercase;
  color: ${(p) => p.theme.greys.shade70};
  text-align: right;
`;

export const SynopsisTimestamp: FC<SynopsisTimestampProps> = ({timestamp}) => (
  <StyledTimestampDiv>
    <InteractiveDateTimeFormatter value={timestamp} relativeFormat={RelativeDateTimeFormatsEnum.SHORT} />
  </StyledTimestampDiv>
);
